<template>
  <div class="max-w-full mx-auto px-6 py-6">
    <h2 class="text-2xl font-semibold mb-5 dark:text-gray-100 text-center">Flat Fee Calculator</h2>

    <!-- Full-width Header Section -->
    <div class="w-full mb-8">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
        <!-- Company Name -->
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Company Name</label>
          <input type="text" v-model="data.company"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
        </div>

        <!-- Date -->
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Date</label>
          <input type="date" v-model="data.date"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
        </div>

        <!-- Discount -->
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Discount</label>
          <div class="mt-1 flex rounded-md shadow-sm">
            <input type="text" v-model="data.discount"
              class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
            <span
              class="inline-flex items-center px-3 rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 dark:bg-gray-500 dark:border-gray-900 dark:text-gray-100">%</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content - Two Column Layout with Tables -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- Left Column -->
      <div>
        <!-- Service Types Table -->
        <div class="overflow-x-auto">
          <table class="w-full border-collapse min-w-[500px]">
            <thead>
              <tr>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                  Support Type</th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                  Count</th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                  Waived</th>
                <th
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                  Discount</th>
              </tr>
            </thead>
            <tbody class="bg-white dark:bg-gray-500">
              <tr>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">Locations</td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <input type="text" v-model="data.locations.count"
                    class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <input type="text" v-model="data.locations.waived"
                    class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <input type="text" v-model="data.locations.discount"
                    class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                </td>
              </tr>
              <tr>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">Servers</td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <input type="text" v-model="data.servers.count"
                    class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <input type="text" v-model="data.servers.waived"
                    class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <input type="text" v-model="data.servers.discount"
                    class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                </td>
              </tr>
              <tr>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">Standard Users</td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <input type="text" v-model="data.workstations.count"
                    class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <input type="text" v-model="data.workstations.waived"
                    class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <input type="text" v-model="data.workstations.discount"
                    class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                </td>
              </tr>
              <tr>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">Cloud Users<br>(if you
                  want SB quote created use this input only)</td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <input type="text" v-model="data.clients.count"
                    class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <input type="text" v-model="data.clients.waived"
                    class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <input type="text" v-model="data.clients.discount"
                    class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                </td>
              </tr>
              <tr>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">Dedicated Level I Tech
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <input type="number" step="0.5" v-model="data.insourced.count" max="25" min="0"
                    class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                </td>
                <td class="px-6 py-4 whitespace-nowrap" colspan="2"></td>
              </tr>
              <tr>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">Dedicated Level II Tech
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <input type="number" step="0.5" v-model="data.level2.count" max="25" min="0"
                    class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                </td>
                <td class="px-6 py-4 whitespace-nowrap" colspan="2"></td>
              </tr>
              <tr>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">Co-Location Amps</td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <input type="number" step="0.25" v-model="data.colocation.count" min="0"
                    class="block w-full rounded-md border-gray-300 shadow-sm dark:bg-gray-400 dark:border-gray-900 dark:text-gray-100">
                </td>
                <td class="px-6 py-4 whitespace-nowrap" colspan="2"></td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Exclude Licensing Costs -->
        <div class="mt-6">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-100">Check any to EXCLUDE licensing
            costs:</label>
          <div class="mt-2 grid grid-cols-2 gap-2">
            <div class="flex items-center">
              <input type="checkbox" v-model="data.backupserver"
                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded dark:border-gray-900">
              <label class="ml-2 text-sm text-gray-900 dark:text-gray-100">Backup Server</label>
            </div>
            <div class="flex items-center">
              <input type="checkbox" v-model="data.backup365"
                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded dark:border-gray-900">
              <label class="ml-2 text-sm text-gray-900 dark:text-gray-100">Backup 365</label>
            </div>
            <div class="flex items-center">
              <input type="checkbox" v-model="data.huntress_edr"
                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded dark:border-gray-900">
              <label class="ml-2 text-sm text-gray-900 dark:text-gray-100">Huntress - Managed EDR</label>
            </div>
            <div class="flex items-center">
              <input type="checkbox" v-model="data.huntress_itdr"
                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded dark:border-gray-900">
              <label class="ml-2 text-sm text-gray-900 dark:text-gray-100">Huntress - Managed ITDR</label>
            </div>
            <div class="flex items-center">
              <input type="checkbox" v-model="data.iron"
                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded dark:border-gray-900">
              <label class="ml-2 text-sm text-gray-900 dark:text-gray-100">Ironscales</label>
            </div>
            <div class="flex items-center">
              <input type="checkbox" v-model="data.screenconnect"
                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded dark:border-gray-900">
              <label class="ml-2 text-sm text-gray-900 dark:text-gray-100">Screen Connect</label>
            </div>
            <div class="flex items-center">
              <input type="checkbox" v-model="data.mdm"
                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded dark:border-gray-900">
              <label class="ml-2 text-sm text-gray-900 dark:text-gray-100">MDM</label>
            </div>
            <div class="flex items-center">
              <input type="checkbox" v-model="data.ninja"
                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded dark:border-gray-900">
              <label class="ml-2 text-sm text-gray-900 dark:text-gray-100">NinjaOne</label>
            </div>
            <div class="flex items-center">
              <input type="checkbox" v-model="data.hosting"
                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded dark:border-gray-900">
              <label class="ml-2 text-sm text-gray-900 dark:text-gray-100">Site Hosting</label>
            </div>
            <div class="flex items-center">
              <input type="checkbox" v-model="data.voip"
                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded dark:border-gray-900">
              <label class="ml-2 text-sm text-gray-900 dark:text-gray-100">VoIP</label>
            </div>
            <div class="flex items-center">
              <input type="checkbox" v-model="data.compliance"
                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded dark:border-gray-900">
              <label class="ml-2 text-sm text-gray-900 dark:text-gray-100">Compliance</label>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Column -->
      <div>
        <!-- Calculation Results Table -->
        <table class="w-full border-collapse">
          <thead>
            <tr>
              <th
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                Base</th>
              <th
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                Waived</th>
              <th
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                Discount</th>
              <th
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider dark:text-gray-300">
                Total</th>
            </tr>
          </thead>
          <tbody class="bg-white dark:bg-gray-500">
            <!-- Each row with exact same height as input rows -->
            <tr>
              <td class="px-6 py-6 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(calcBase('locations')) }}</td>
              <td class="px-6 py-6 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(calcWaived('locations')) }}</td>
              <td class="px-6 py-6 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(calcDiscount('locations')) }}</td>
              <td class="px-6 py-6 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(data.locations.cost) }}</td>
            </tr>
            <tr>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(calcBase('servers')) }}</td>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(calcWaived('servers')) }}</td>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(calcDiscount('servers')) }}</td>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(data.servers.cost) }}</td>
            </tr>
            <tr>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(calcBase('workstations')) }}</td>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(calcWaived('workstations')) }}</td>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(calcDiscount('workstations')) }}</td>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(data.workstations.cost) }}</td>
            </tr>
            <tr>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(calcBase('clients')) }}</td>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(calcWaived('clients')) }}</td>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(calcDiscount('clients')) }}</td>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(data.clients.cost) }}</td>
            </tr>
            <tr>
              <td class="px-6 py-6 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(calcBase('insourced')) }}</td>
              <td class="px-6 py-6 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">N/A</td>
              <td class="px-6 py-6 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">N/A</td>
              <td class="px-6 py-6 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(data.insourced.cost) }}</td>
            </tr>
            <tr>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(calcBase('level2')) }}</td>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">N/A</td>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">N/A</td>
              <td class="px-6 py-7 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(data.level2.cost) }}</td>
            </tr>
            <tr>
              <td class="px-6 py-6 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(calcBase('colocation')) }}</td>
              <td class="px-6 py-6 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">N/A</td>
              <td class="px-6 py-6 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">N/A</td>
              <td class="px-6 py-6 whitespace-nowrap text-sm text-gray-900 dark:text-gray-100">{{
                formatCurrency(data.colocation.cost) }}</td>
            </tr>
            <tr class="border-t-2 border-double border-gray-300 dark:border-gray-700">
              <td class="px-6 py-7 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-gray-100" colspan="3">
                Total Monthly Cost:</td>
              <td class="px-6 py-7 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-gray-100">{{
                formatCurrency(totalFlatFee) }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Message area for status/errors -->
        <div v-if="message" class="mt-4 p-4 rounded"
          :class="messageType === 'error' ? 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100' : 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100'">
          {{ message }}
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="mt-8 flex justify-center space-x-4">
      <button @click="generatePDF"
        class="px-4 py-2 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600">
        Download PDF
      </button>
    </div>

    <!-- Email Section -->

  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      rates: {},
      data: {
        company: '',
        date: new Date().toISOString().split('T')[0], // Today's date
        discount: 0,
        email: '',
        locations: { count: 0, waived: 0, discount: 0, cost: 0 },
        servers: { count: 0, waived: 0, discount: 0, cost: 0 },
        workstations: { count: 0, waived: 0, discount: 0, cost: 0 },
        clients: { count: 0, waived: 0, discount: 0, cost: 0 },
        insourced: { count: 0, cost: 0, nodiscount: true },
        level2: { count: 0, cost: 0, nodiscount: true },
        colocation: { count: 0, cost: 0, nodiscount: true },
        backupserver: false,
        backup365: false,
        huntress_edr: false,
        huntress_itdr: false,
        iron: false,
        screenconnect: false,
        mdm: false,
        ninja: true,
        hosting: false,
        voip: true,
        compliance: true
      },
      loading: false,
      message: '',
      messageType: 'info'
    };
  },
  computed: {
    totalFlatFee() {
      return this.data.locations.cost +
        this.data.servers.cost +
        this.data.workstations.cost +
        this.data.clients.cost +
        this.data.insourced.cost +
        this.data.level2.cost +
        this.data.colocation.cost;
    }
  },
  watch: {
    'data': {
      handler(newVal, oldVal) {
        // Match the old Angular behavior
        if (newVal.discount !== oldVal.discount) {
          this.data.servers.discount = newVal.discount;
          this.data.locations.discount = newVal.discount;
          this.data.workstations.discount = newVal.discount;
          this.data.clients.discount = newVal.discount;
        }
        this.updateCosts();
      },
      deep: true
    }
  },
  methods: {
    calcBase(type) {
      if (!this.rates[type] || !this.data[type].count) return 0;
      return this.rates[type] * this.data[type].count;
    },
    calcWaived(type) {
      if (!this.rates[type] || !this.data[type].waived) return 0;
      return this.rates[type] * this.data[type].waived * -1;
    },
    calcDiscount(type) {
      if (this.data[type].nodiscount) return 0;
      if (!this.rates[type] || !this.data[type].discount || !this.data[type].count) return 0;
      const num = this.data[type].count - this.data[type].waived;
      const cost = num * this.rates[type];
      const d = this.data[type].discount ? this.data[type].discount : 0;
      return cost * (d / 100) * -1;
    },
    formatCurrency(value) {
      if (!value) return '$0.00';
      return '$' + parseFloat(value).toFixed(2);
    },
    updateCosts() {
      // Calculate costs for each service type
      const types = ['locations', 'servers', 'workstations', 'clients', 'insourced', 'level2', 'colocation'];
      types.forEach(type => {
        this.data[type].cost = this.calcBase(type);
        if (!this.data[type].nodiscount) {
          this.data[type].cost += this.calcWaived(type) + this.calcDiscount(type);
        }
      });
    },
    // NEW METHOD: Added to handle default inclusions on SB contracts
    SBInclusionDefaults() {
      const cloudCount = Number(this.data.clients.count || 0);
      const standardCount = Number(this.data.workstations.count || 0);
      const locationsCount = Number(this.data.locations.count || 0);
      if (cloudCount > 0 && locationsCount == 0 && standardCount === 0) {
        this.data.ninja = true;
        this.data.huntress_edr = true;
        this.data.huntress_itdr = false;
        this.data.backupserver = true;
        this.data.mdm = true;
        this.data.screenconnect = true;
        this.data.hosting = true;
        this.data.voip = true;
        this.data.backup365 = false;
        this.data.iron = false;
      }
    },
    validateEmail() {
      if (this.data.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.data.email)) {
        this.message = 'Please enter a valid email address.';
        this.messageType = 'error';
        return false;
      }
      return true;
    },
    validateData() {
      if (!this.data.company) {
        this.message = 'Please enter a company name.';
        this.messageType = 'error';
        return false;
      }

      // Validate that at least one service has a count
      const hasServices =
        this.data.locations.count > 0 ||
        this.data.servers.count > 0 ||
        this.data.workstations.count > 0 ||
        this.data.clients.count > 0 ||
        this.data.insourced.count > 0 ||
        this.data.level2.count > 0 ||
        this.data.colocation.count > 0;

      if (!hasServices) {
        this.message = 'Please add at least one service.';
        this.messageType = 'error';
        return false;
      }

      return true;
    },
    async fetchRates() {
      this.$updateLoading?.(1);
      this.loading = true;
      try {
        const response = await axios.get('/fee-calculator/init');
        if (response.data.result === 'success') {
          this.rates = response.data.rates;
          this.updateCosts();
        } else {
          this.message = 'Failed to load rates. Please try again.';
          this.messageType = 'error';
        }
      } catch (error) {
        console.error('Error loading rates:', error);
        this.message = 'Failed to load rates. Please try again.';
        this.messageType = 'error';
      } finally {
        this.loading = false;
        this.$updateLoading?.(-1);
      }
    },
    async showSheet() {
      if (!this.validateData()) return;

      this.loading = true;
      this.message = 'Generating sheet...';
      this.messageType = 'info';

      try {
        // Format data for compatibility with old code - using prepareDataForAPI method
        const dataToSend = {
          rate: JSON.stringify(this.rates),
          info: JSON.stringify(this.prepareDataForAPI())
        };

        // Use axios with proper response type for file handling
        const response = await axios.get('/fee-calculator/print', {
          params: dataToSend,
          responseType: 'blob' // Important for file handling
        });

        // Create a blob URL but instead of downloading, open in new tab
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        // Open the PDF in a new tab
        window.open(url, '_blank');

        this.message = 'Sheet opened successfully!';
        this.messageType = 'info';
      } catch (error) {
        console.error('Error showing sheet:', error);
        this.message = 'Failed to show sheet. Please try again.';
        this.messageType = 'error';
      } finally {
        this.loading = false;
      }
    },
    async generatePDF() {
      if (!this.validateData()) return;

      this.loading = true;
      this.message = 'Generating PDF...';
      this.messageType = 'info';

      try {
        // Format data for compatibility with old code
        const dataToSend = {
          rate: JSON.stringify(this.rates),
          info: JSON.stringify(this.prepareDataForAPI())
        };

        // Use axios with proper response type for file downloads
        const response = await axios.get('/fee-calculator/print', {
          params: dataToSend,
          responseType: 'blob'
        });

        // Create a filename based on company name
        let filename = `AIM_Rates_for_${this.data.company.replace(/[^a-zA-Z0-9]/g, '_')}.pdf`;

        // Create blob and download
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();

        // Clean up
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);

        this.message = 'PDF downloaded successfully!';
        this.messageType = 'info';
      } catch (error) {
        console.error('Error generating PDF:', error);
        this.message = 'Failed to generate PDF. Please try again.';
        this.messageType = 'error';
      } finally {
        this.loading = false;
      }
    },
    async sendEmail() {
      if (!this.validateData() || !this.validateEmail()) return;

      if (!this.data.email) {
        this.message = 'Please enter an email address.';
        this.messageType = 'error';
        return;
      }

      this.loading = true;
      this.$updateLoading?.(1);
      this.message = 'Sending email...';
      this.messageType = 'info';

      try {
        // Convert checkbox values to strings to match old code
        const dataToSend = {
          rate: this.rates,
          info: this.prepareDataForAPI()
        };

        // Send email via API
        const response = await axios.post('/fee-calculator/send-email', dataToSend);

        if (response.data.error) {
          this.message = response.data.error;
          this.messageType = 'error';
        } else {
          this.message = `Email successfully sent to ${this.data.email}`;
          this.messageType = 'info';
          this.data.email = ''; // Clear email field after successful send
        }
      } catch (error) {
        console.error('Error sending email:', error);
        this.message = 'Failed to send email. Please try again.';
        this.messageType = 'error';
      } finally {
        this.loading = false;
        this.$updateLoading?.(-1);
      }
    },
    // Prepare data to match old code format
    prepareDataForAPI() {
      // Convert boolean checkbox values to 'true'/'false' strings to match old code
      const processedData = JSON.parse(JSON.stringify(this.data));
      processedData.backupserver = String(this.data.backupserver);
      processedData.backup365 = String(this.data.backup365);
      processedData.huntress_edr = String(this.data.huntress_edr);
      processedData.huntress_itdr = String(this.data.huntress_itdr);
      processedData.iron = String(this.data.iron);
      processedData.screenconnect = String(this.data.screenconnect);
      processedData.mdm = String(this.data.mdm);
      processedData.ninja = String(this.data.ninja);
      processedData.hosting = String(this.data.hosting);
      processedData.voip = String(this.data.voip);
      processedData.compliance = String(this.data.compliance);

      return processedData;
    }
  },
  // UPDATED WATCHERS: Added calls to updateNinjaCheckbox() in these two
  watch: {
    'data.locations.count'() { this.updateCosts(); this.SBInclusionDefaults(); },
    'data.locations.waived'() { this.updateCosts(); },
    'data.locations.discount'() { this.updateCosts(); },
    'data.servers.count'() { this.updateCosts(); },
    'data.servers.waived'() { this.updateCosts(); },
    'data.servers.discount'() { this.updateCosts(); },
    'data.workstations.count'() { this.updateCosts(); this.SBInclusionDefaults(); },
    'data.workstations.waived'() { this.updateCosts(); },
    'data.workstations.discount'() { this.updateCosts(); },
    'data.clients.count'() { this.updateCosts(); this.SBInclusionDefaults(); },
    'data.clients.waived'() { this.updateCosts(); },
    'data.clients.discount'() { this.updateCosts(); },
    'data.insourced.count'() { this.updateCosts(); },
    'data.level2.count'() { this.updateCosts(); },
    'data.colocation.count'() { this.updateCosts(); },
    'data.discount'() {
      // Apply global discount to all items
      ['locations', 'servers', 'workstations', 'clients'].forEach(type => {
        this.data[type].discount = this.data.discount;
      });
      this.updateCosts();
    }
  },
  mounted() {
    this.fetchRates();
  }
};
</script>